/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateGlossaryDto } from '../models';
// @ts-ignore
import type { GlossaryEntryDto } from '../models';
// @ts-ignore
import type { UpdateGlossaryDto } from '../models';
/**
 * GlossaryApi - axios parameter creator
 * @export
 */
export const GlossaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateGlossaryDto} createGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerCreateGlossaryTerm: async (createGlossaryDto: CreateGlossaryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGlossaryDto' is not null or undefined
            assertParamExists('glossaryControllerCreateGlossaryTerm', 'createGlossaryDto', createGlossaryDto)
            const localVarPath = `/api/glossary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGlossaryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerDeleteGlossaryTerm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('glossaryControllerDeleteGlossaryTerm', 'id', id)
            const localVarPath = `/api/glossary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerGetAllGlossaryTerms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/glossary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerGetGlossaryTerm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('glossaryControllerGetGlossaryTerm', 'id', id)
            const localVarPath = `/api/glossary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateGlossaryDto} updateGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerUpdateGlossaryTerm: async (id: string, updateGlossaryDto: UpdateGlossaryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('glossaryControllerUpdateGlossaryTerm', 'id', id)
            // verify required parameter 'updateGlossaryDto' is not null or undefined
            assertParamExists('glossaryControllerUpdateGlossaryTerm', 'updateGlossaryDto', updateGlossaryDto)
            const localVarPath = `/api/glossary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlossaryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlossaryApi - functional programming interface
 * @export
 */
export const GlossaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlossaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateGlossaryDto} createGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async glossaryControllerCreateGlossaryTerm(createGlossaryDto: CreateGlossaryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGlossaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.glossaryControllerCreateGlossaryTerm(createGlossaryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlossaryApi.glossaryControllerCreateGlossaryTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async glossaryControllerDeleteGlossaryTerm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.glossaryControllerDeleteGlossaryTerm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlossaryApi.glossaryControllerDeleteGlossaryTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async glossaryControllerGetAllGlossaryTerms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlossaryEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.glossaryControllerGetAllGlossaryTerms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlossaryApi.glossaryControllerGetAllGlossaryTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async glossaryControllerGetGlossaryTerm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlossaryEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.glossaryControllerGetGlossaryTerm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlossaryApi.glossaryControllerGetGlossaryTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateGlossaryDto} updateGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async glossaryControllerUpdateGlossaryTerm(id: string, updateGlossaryDto: UpdateGlossaryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateGlossaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.glossaryControllerUpdateGlossaryTerm(id, updateGlossaryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlossaryApi.glossaryControllerUpdateGlossaryTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlossaryApi - factory interface
 * @export
 */
export const GlossaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlossaryApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateGlossaryDto} createGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerCreateGlossaryTerm(createGlossaryDto: CreateGlossaryDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateGlossaryDto> {
            return localVarFp.glossaryControllerCreateGlossaryTerm(createGlossaryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerDeleteGlossaryTerm(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.glossaryControllerDeleteGlossaryTerm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerGetAllGlossaryTerms(options?: RawAxiosRequestConfig): AxiosPromise<Array<GlossaryEntryDto>> {
            return localVarFp.glossaryControllerGetAllGlossaryTerms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerGetGlossaryTerm(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GlossaryEntryDto> {
            return localVarFp.glossaryControllerGetGlossaryTerm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateGlossaryDto} updateGlossaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        glossaryControllerUpdateGlossaryTerm(id: string, updateGlossaryDto: UpdateGlossaryDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateGlossaryDto> {
            return localVarFp.glossaryControllerUpdateGlossaryTerm(id, updateGlossaryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlossaryApi - object-oriented interface
 * @export
 * @class GlossaryApi
 * @extends {BaseAPI}
 */
export class GlossaryApi extends BaseAPI {
    /**
     * 
     * @param {CreateGlossaryDto} createGlossaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    public glossaryControllerCreateGlossaryTerm(createGlossaryDto: CreateGlossaryDto, options?: RawAxiosRequestConfig) {
        return GlossaryApiFp(this.configuration).glossaryControllerCreateGlossaryTerm(createGlossaryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    public glossaryControllerDeleteGlossaryTerm(id: string, options?: RawAxiosRequestConfig) {
        return GlossaryApiFp(this.configuration).glossaryControllerDeleteGlossaryTerm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    public glossaryControllerGetAllGlossaryTerms(options?: RawAxiosRequestConfig) {
        return GlossaryApiFp(this.configuration).glossaryControllerGetAllGlossaryTerms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    public glossaryControllerGetGlossaryTerm(id: string, options?: RawAxiosRequestConfig) {
        return GlossaryApiFp(this.configuration).glossaryControllerGetGlossaryTerm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateGlossaryDto} updateGlossaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    public glossaryControllerUpdateGlossaryTerm(id: string, updateGlossaryDto: UpdateGlossaryDto, options?: RawAxiosRequestConfig) {
        return GlossaryApiFp(this.configuration).glossaryControllerUpdateGlossaryTerm(id, updateGlossaryDto, options).then((request) => request(this.axios, this.basePath));
    }
}

